<template>
  <layout-register :step="step" :title-step="$t('m85')" class="step-5">
    <form @submit="sendGeneralInformation">
      <div class="row">
        <div class="col-12">
          <a-radio-gender
            v-model="form.gender.value"
            name="gender"
            :error="form.gender.error.length > 0"
            :errorMessage="form.gender.error"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-xs-12 col-sm-12 col-12">
          <div class="row">
            <div class="col-12">
              <a-input
                :label="$t('m83')"
                placeholder="Cristobal Andres"
                name="name"
                v-model="form.name.value"
                @keyup="evaluateInput"
                :error="form.name.error.length > 0"
                :errorMessage="form.name.error"
              />
            </div>
            <div class="col-12">
              <a-input
                :label="$t('m84')"
                placeholder="PRADENAS RIQUELME"
                name="lastname"
                v-model="form.lastname.value"
                @keyup="evaluateInput"
                :error="form.lastname.error.length > 0"
                :errorMessage="form.lastname.error"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xs-12 col-sm-12 col-12">
          <div class="row">
            <div
              v-if="documentTypeId == 1 || documentTypeId == 2"
              class="col-12"
            >
              <a-input
                :label="$t('m86')"
                :placeholder="$t('m184')"
                name="rut"
                v-model="form.rut.value"
                @keyup="evaluateInput"
                :error="form.rut.error.length > 0"
                :errorMessage="form.rut.error"
              />
            </div>
            <div v-else class="col-12">
              <a-input
                :label="$t('m86')"
                :placeholder="$t('m184')"
                name="passport"
                v-model="form.passport.value"
                @keyup="evaluateInput"
                :error="form.passport.error.length > 0"
                :errorMessage="form.passport.error"
              />
            </div>
            <div class="col-12">
              <a-date-picker
                v-model="form.birthday.value"
                :label="$t('m87')"
                name="birthday"
                @keyup="evaluateInput"
                :error="form.birthday.error.length > 0"
                :errorMessage="form.birthday.error"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-xs-12 col-sm-12 col-12">
          <div class="row">
            <div class="col-12 row-title">{{ $t('m88') }}</div>
            <div class="col-12">
              <a-date-picker
                v-model="form.idIssueDay.value"
                :label="$t('m89')"
                name="idIssueDay"
                @keyup="evaluateInput"
                :error="form.idIssueDay.error.length > 0"
                :errorMessage="form.idIssueDay.error"
              />
            </div>
            <div class="col-12">
              <a-date-picker
                v-model="form.idExpirationDay.value"
                :label="$t('m90')"
                name="idExpirationDay"
                @keyup="evaluateInput"
                :error="form.idExpirationDay.error.length > 0"
                :errorMessage="form.idExpirationDay.error"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xs-12 col-sm-12 col-12">
          <div class="row">
            <div class="col-12 row-title">{{ $t('m91') }}</div>
            <div class="col-12">
              <a-date-picker
                v-model="form.driveIssueDay.value"
                :label="$t('m89')"
                name="driveIssueDay"
                @keyup="evaluateInput"
                :error="form.driveIssueDay.error.length > 0"
                :errorMessage="form.driveIssueDay.error"
              />
            </div>
            <div class="col-12">
              <a-date-picker
                v-model="form.driveExpirationDay.value"
                :label="$t('m90')"
                name="driveExpirationDay"
                @keyup="evaluateInput"
                :error="form.driveExpirationDay.error.length > 0"
                :errorMessage="form.driveExpirationDay.error"
              />
            </div>
            <div class="col-12">
              <a-checkbox-license
                v-model="form.driveLicenseType.value"
                name="driveLicenseType"
                @keyup="evaluateInput"
                :error="form.driveLicenseType.error.length > 0"
                :errorMessage="form.driveLicenseType.error"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-7 col-xs-12 col-sm-12 col-12">
          <a-btn
            class="next-step-button"
            primary
            type="submit"
            :loading="loadingBtn"
          >
            {{ $t('m15') }} 8
          </a-btn>
        </div>
      </div>
    </form>
  </layout-register>
</template>

<script>
import AInput from '@/components/ui/AInput';
import ACheckboxLicense from '@/components/ui/ACheckboxLicense';
import ADatePicker from '@/components/ui/ADatePicker';
import ARadioGender from '@/components/ui/ARadioGender';
import ABtn from '@/components/ui/ABtn';
import { validator } from '@/mixins/validator.js';
import { rut } from '@/utils/formRules.js';

export default {
  name: 'GeneralInformation',
  components: {
    AInput,
    ACheckboxLicense,
    ARadioGender,
    ADatePicker,
    ABtn,
  },
  mixins: [validator],
  data() {
    return {
      modal: false,
      form: {
        gender: {
          value: '',
          error: '',
          rules: [],
        },
        name: {
          value: '',
          error: '',
          rules: [],
        },
        lastname: {
          value: '',
          error: '',
          rules: [],
        },
        rut: {
          value: '',
          error: '',
          rules: [],
        },
        passport: {
          value: '',
          error: '',
          rules: [],
        },
        birthday: {
          value: '',
          error: '',
          rules: [],
        },
        idIssueDay: {
          value: '',
          error: '',
          rules: [],
        },
        idExpirationDay: {
          value: '',
          error: '',
          rules: [],
        },
        driveIssueDay: {
          value: '',
          error: '',
          rules: [],
        },
        driveExpirationDay: {
          value: '',
          error: '',
          rules: [],
        },
        driveLicenseType: {
          value: '',
          error: '',
          rules: [],
        },
      },
      step: 7,
      loadingBtn: false,
      documentTypeId: null,
    };
  },
  computed: {},
  created() {
    this.loadingBtn = true;
    this.$store
      .dispatch('register/getGeneralInformation')
      .then(resp => {
        if (resp.nextStep === 'GENERAL_INFORMATION') {
          this.form.gender.value = resp.gender;
          this.form.name.value = resp.name;
          this.form.lastname.value = resp.lastname;
          this.form.rut.value = resp.rut;
          this.form.passport.value = resp.passport;
          this.form.birthday.value = resp.birthday;
          this.form.idIssueDay.value = resp.idIssueDay;
          this.form.idExpirationDay.value = resp.idExpirationDay;
          this.form.driveIssueDay.value = resp.driveIssueDay;
          this.form.driveExpirationDay.value = resp.driveExpirationDay;
          this.form.driveLicenseType.value = resp.driveLicenseType;
        } else {
          if (resp.tocStatus) {
            if (resp.tocStatus >= 200 && resp.tocStatus < 500) {
              this.$router.push({ name: 'critical-error' });
            } else {
              this.$router.push({ name: 'critical-unknown-error' });
            }
          } else {
            if (resp.biometricResult !== null) {
              this.$router.push({ name: 'critical-error' });
            } else {
              this.$router.push({ name: 'critical-unknown-error' });
            }
          }
        }
      })
      .finally(() => {
        this.loadingBtn = false;
      });
  },
  mounted() {
    this.documentTypeId = this.$store.getters['register/documentTypeId'];
    if (!this.documentTypeId) {
      this.$store.dispatch('register/profile').then(() => {
        this.documentTypeId = this.$store.getters['register/documentTypeId'];
        this.setIdentifierRules();
      });
    } else {
      this.setIdentifierRules();
    }
    this.form.gender.rules = [this.rules.required];
    this.form.name.rules = [this.rules.required];
    this.form.lastname.rules = [this.rules.required];
    this.form.birthday.rules = [
      this.rules.required,
      value => {
        return this.rules.dateOfIssue(
          value,
          'La fecha de nacimiento no puede ser una fecha futura',
        );
      },
    ];
    this.form.idIssueDay.rules = [this.rules.required, this.rules.dateOfIssue];
    this.form.idExpirationDay.rules = [
      value => {
        return this.rules.expirationDate(value, 'idIssueDay', this);
      },
      this.rules.required,
    ];
    this.form.driveIssueDay.rules = [
      this.rules.required,
      this.rules.dateOfIssue,
    ];
    this.form.driveExpirationDay.rules = [
      value => {
        return this.rules.expirationDate(value, 'driveIssueDay', this);
      },
      this.rules.required,
    ];
    this.form.driveLicenseType.rules = [
      value => {
        return this.rules.required(
          value,
          'Debe escoger al menos un tipo de licencia',
        );
      },
    ];
  },
  methods: {
    setIdentifierRules() {
      if (this.documentTypeId == 3) {
        this.form.passport.rules = [this.rules.required];
      } else {
        this.form.rut.rules = [this.rules.required, rut];
        this.form.rut.modifiers = [this.modifiers.rut];
      }
    },
    sendGeneralInformation(e) {
      e.preventDefault();
      if (this.validateForm()) {
        this.loadingBtn = true;
        this.$store
          .dispatch('register/generalInformation', {
            birthday: this.form.birthday.value,
            driveExpirationDay: this.form.driveExpirationDay.value,
            driveIssueDay: this.form.driveIssueDay.value,
            driveLicenseType: this.form.driveLicenseType.value,
            gender: this.form.gender.value,
            idExpirationDay: this.form.idExpirationDay.value,
            idIssueDay: this.form.idIssueDay.value,
            lastname: this.form.lastname.value,
            name: this.form.name.value,
            passport: this.form.passport.value,
            rut: this.form.rut.value,
          })
          .then(resp => {
            if (resp.registrationStep) {
              this.$router.push({ name: resp.registrationStep });
            }
          })
          .finally(() => {
            this.loadingBtn = false;
          });
      }
    },
  },
};
</script>
